import { computed, ref } from 'vue';
import { useWindowSize } from '@vueuse/core';
import wootConstants from 'dashboard/constants/globals';

const contactSidebarOpen = ref(false);
const orderSidebarOpen = ref(false);

export function useConversationSidebars() {
  const { width: windowWidth } = useWindowSize();
  const isSmallScreen = computed(
    () => windowWidth.value < wootConstants.SMALL_SCREEN_BREAKPOINT
  );

  const isContactSidebarOpen = computed(() => contactSidebarOpen.value);
  const isOrderSidebarOpen = computed(() => orderSidebarOpen.value);

  const openContactSidebar = () => {
    contactSidebarOpen.value = true;
    if (isSmallScreen.value) orderSidebarOpen.value = false;
  };

  const closeContactSidebar = () => {
    contactSidebarOpen.value = false;
  };

  const openOrderSidebar = () => {
    orderSidebarOpen.value = true;
    if (isSmallScreen.value) contactSidebarOpen.value = false;
  };

  const closeOrderSidebar = () => {
    orderSidebarOpen.value = false;
  };

  const toggleOrderSidebar = () => {
    if (orderSidebarOpen.value) {
      closeOrderSidebar();
    } else {
      openOrderSidebar();
    }
  };

  return {
    isSmallScreen,
    isContactSidebarOpen,
    isOrderSidebarOpen,
    openContactSidebar,
    closeContactSidebar,
    openOrderSidebar,
    closeOrderSidebar,
    toggleOrderSidebar,
  };
}
